import script from "./SyncAppPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncAppPage.vue?vue&type=script&setup=true&lang=ts"

import "./SyncAppPage.vue?vue&type=style&index=0&id=bd881bce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd881bce"]])

export default __exports__